import React, { useCallback, useMemo } from "react";
import "./styles.less";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthingButton } from "../../../components/AuthingButton";

export const ZeroOther = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const text = useMemo(() => {
    return {
      title: t("common.pageLink.title"),
      item: [
        {
          title: t("common.pageLink.finance.title"),
          desc: t("common.pageLink.finance.description"),
          icon:
            "https://files.authing.co/authing-website/page-link-icon-finance.png",
          jumpLink: "/solutions/finance",
        },
        {
          title: t("common.pageLink.manufacture.title"),
          desc: t("common.pageLink.manufacture.description"),
          icon:
            "https://files.authing.co/authing-website/page-linl-icon-manufacture.png",
          jumpLink: "/solutions/manufacturing",
        },
        {
          title: t("common.pageLink.ad.title"),
          desc: t("common.pageLink.ad.description"),
          icon:
            "https://files.authing.co/authing-website/page-link-icon-ad.png",
          jumpLink: "/solutions/ad",
        },
        {
          title: t("common.pageLink.price.title"),
          desc: t("common.pageLink.price.description"),
          icon:
            "https://files.authing.co/authing-website/page-link-icon-price.png",
          jumpLink: "/pricing",
        },
      ],
    };
  }, [t]);

  const renderLi = useCallback(
    (item, itemIndex) => {
      return (
        <div key={itemIndex} className="item">
          <div
            style={{
              height: "100%",
              overflow: "hidden",
            }}
          >
            <div className="icona">
              <img src={item.icon} alt={item.alt} width="100%" />
            </div>
            <div className="title line1">{item.title}</div>
            <div className="desc">{item.desc}</div>
            <AuthingButton
              mode="small"
              onClick={() => {
                window.open(item.jumpLink);
              }}
            >
              {t("common.common-more")}
            </AuthingButton>
          </div>
        </div>
      );
    },
    [t]
  );
  return (
    <div style={{ background: "#f7f8fa" }}>
      <div className="zero-trust-other basic-column">
        <h1 className="manufacturing-title basic-title">{text.title}</h1>
        <div className="pc-show">
          <div className="manufacturing-other-content basic-column">
            {text.item.map((item, itemIndex) => renderLi(item, itemIndex))}
          </div>
        </div>
        <div className="pad-show mobile-show">
          <div className="manufacturing-other-content basic-column">
            <div className="flex">
              {text.item
                .slice(0, 2)
                .map((item, itemIndex) => renderLi(item, itemIndex))}
            </div>
            <div className="flex">
              {text.item
                .slice(2, 4)
                .map((item, itemIndex) => renderLi(item, itemIndex))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
